import React, { useState, useEffect } from 'react';
import {
    FormLabel,
    Button,
    MultiSelect,
    ToggleSmall,
} from 'carbon-components-react';
import { boolean, select, text, object } from '@storybook/addon-knobs';
import { ChevronDown16 } from '@carbon/icons-react';
import './Filters.scss';
import i18n from "../../../i18n";
import * as Constants from '../../../requests/URLConstants'
import callPostApi from "../../../requests/PostRequests";
import * as configConst from "../../../config/Constants";
import * as workspaces from "../../../config/WorkspaceConstants"

var config = require('../../../config/appConfig.json');


const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};
const types = {
    'Default (default)': 'default',
    'Inline (inline)': 'inline',
};
const directions = {
    'Bottom (default)': 'bottom',
    'Top ': 'top',
};

const multiselectprops = {
    id: text('MultiSelect ID (id)', 'carbon-multiselect-example'),
    light: boolean('Light variant (light)', false),
    useTitleInItem: boolean('Show tooltip on hover', false),
    type: select('UI type (Only for `<MultiSelect>`) (type)', types, 'default'),
    size: select('Field size (size)', sizes, undefined) || undefined,
    direction: select('Dropdown direction (direction)', directions, 'bottom'),
    invalid: boolean('Show form validation UI (invalid)', false),
    invalidText: text(
        'Form validation UI content (invalidText)',
        'Invalid Selection'
    ),
    warn: boolean('Show warning state (warn)', false),
    warnText: text(
        'Warning state text (warnText)',
        'Selecting more items may increase processing time'
    ),
    listBoxMenuIconTranslationIds: object(
        'Listbox menu icon translation IDs (for translateWithId callback)',
        {
            'close.menu': 'Close menu',
            'open.menu': 'Open menu',
            'clear.all': 'Clear all',
            'clear.selection': 'Clear selection',
        }
    ),
    selectionFeedback: select(
        'Selection feedback',
        ['top', 'fixed', 'top-after-reopen'],
        'top-after-reopen'
    )
};

const Filters = props => {

    const [filterSelections, setFilterSelections] = useState(props.filterSelections);
    const [disabledSelects, setDisabledSelects] = useState(props.disabledSelects);
    const [clients, setClients] = useState(props.filterData.clients);
    const [assigneesDisable, setassigneeDisable] = useState(false);
    const [isAssignedTome, setAssignedTome] = useState(false);
    const [showSelectedFranchise, setShowSelectedFranchise] = useState(false);
    const [clientKey, setClientKey] = useState(true);
    const [filterSIDData, setfilterSIDData] = useState();
    const [sourceTypeData, setSourceTypeData] = useState();
    const [filterSIDKey, setFilterSIDKey] = useState(true);
    const [sourceTypeKey, setSourceTypeKey] = useState(true);
    const [sourceSIDDisable, setSourceSIDDisable] = useState(props.filterSelections.client.length !== 0 ? false : true);
    const [sapSIDData, setSapSIDData] = useState();
    const [sapSIDKey, setSapSIDKey] = useState(true);
    const [SIDDisable, setSIDDisable] = useState(props.filterSelections.client.length !== 0 ? false : true);

    //console.log("FilterProps",props)

    useEffect(() => {
        setFilterSelections(props.filterSelections);
        getClientData(props.filterSelections.franchise);
        props.filterSelections.client && props.workspace === workspaces.custom_ops && getCustomFilterData(props.filterSelections.client);
        props.filterSelections.client && props.workspace === workspaces.sap_ops && getSAPFilterData(props.filterSelections.client);
        if (props.filterSelections.franchise.length !== 0) {
            setDisabledSelects({ 'client-select': false });
        }
        handleAssignedToMe(false);
        if (props.filterSelections && props.filterSelections.assignee_email && props.filterSelections.assignee_email.length > 0) {
            setAssignedTome(true);
        } else {
            setAssignedTome(false);
        }
    }, [props]);

    useEffect(() => {
        if (showSelectedFranchise) {
            let selectedClientsList = [];
            selectedClientsList.push(clients.map((clientItem) => { return clientItem.name }));
            let selectedClients = filterSelections.client.filter(item => selectedClientsList[0].includes(item));
            setFilterSelections({ ...filterSelections, "client": selectedClients });
            setClientKey(!clientKey);
            if (props.workspace === workspaces.custom_ops) {
                handleCustomClientSelection(selectedClients)
            }
            if (props.workspace === workspaces.sap_ops) {
                handleSAPClientSelection(selectedClients)
            }
        }
    }, [clients])

    useEffect(() => {
        if (props.workspace === workspaces.custom_ops && filterSelections && filterSelections.filter_sid && filterSIDData) {
            if (filterSIDData.length > 0) {
                let selectedValues = filterSIDData.filter(item => filterSelections.filter_sid.some(selecteditem => selecteditem === item.name)).map(key => key.name);
                setFilterSelections({ ...filterSelections, "filter_sid": selectedValues });
                setFilterSIDKey(!filterSIDKey);
            } else {
                setFilterSelections({ ...filterSelections, "filter_sid": [] });
                setFilterSIDKey(!filterSIDKey);
            }
        }
    }, [filterSIDData]);

    useEffect(() => {
        if (props.workspace === workspaces.custom_ops && filterSelections && filterSelections.source_type && sourceTypeData) {
            if (sourceTypeData.length > 0) {
                let selectedValues = sourceTypeData.filter(item => filterSelections.source_type.some(selecteditem => selecteditem === item.name)).map(key => key.name);
                setFilterSelections({ ...filterSelections, "source_type": selectedValues });
                setSourceTypeKey(!sourceTypeKey);
            } else {
                setFilterSelections({ ...filterSelections, "source_type": [] });
                setSourceTypeKey(!sourceTypeKey);
            }
        }
    }, [sourceTypeData]);

    useEffect(() => {
        if (props.workspace === workspaces.sap_ops && filterSelections && filterSelections.sid && sapSIDData) {
            if (sapSIDData.length > 0) {
                let selectedValues = sapSIDData.filter(item => filterSelections.sid.some(selecteditem => selecteditem === item.name)).map(key => key.name);
                setFilterSelections({ ...filterSelections, "sid": selectedValues });
                setSapSIDKey(!sapSIDKey);
            }
            else {
                setFilterSelections({ ...filterSelections, "sid": [] });
                setSapSIDKey(!sapSIDKey);
            }

        }
    }, [sapSIDData]);

    const handleFranchiseSelectionChange = (event) => {
        let franchiseLength = event.selectedItems.length;
        let oldFranchiseLength = filterSelections.franchise.length;
        if (oldFranchiseLength > franchiseLength) {
            setShowSelectedFranchise(true);
        }
        else setShowSelectedFranchise(false);
        var selectedValues = event.selectedItems.map(function (k, v) {
            return k.name;
        });
        let noOfFranchises = filterSelections.franchise.length;
        setFilterSelections({ ...filterSelections, "franchise": selectedValues });
        getClientData(selectedValues);

        if (selectedValues.length > 0) {
            setDisabledSelects({ 'client-select': false });
        } else {
            let element = document.getElementById('client-select');
            element.firstChild.click();
            setDisabledSelects({ 'client-select': true });
        }
    };

    const getClientData = (franchiseSelections) => {
        let request = {};
        let filtersArray = [];
        if (franchiseSelections != null && franchiseSelections.length > 0) {
            filtersArray = franchiseSelections;
        }
        request.alertType = props.alertType;
        request.filtersArray = filtersArray;
        if (props.workspace === workspaces.automation_ops) {
            request.automation = workspaces.automation_ops;
        }
        if (props.workspace === workspaces.sap_ops) {
            request.sap = workspaces.sap_ops;
        }
        if (props.workspace === workspaces.custom_ops) {
            request.custom = workspaces.custom_ops;
        }
        if (props.workspace === workspaces.salesforce_ops) {
            request.salesforce = workspaces.salesforce_ops;
        }

        callPostApi(Constants.GETCLIENTSURL, {
            'Content-Type': 'application/json'
        }, request)
            .then(resp => {
                let clientsList = [];
                if (resp && resp.aggregations && resp.aggregations.filtered && resp.aggregations.filtered.clients && resp.aggregations.filtered.clients.buckets) {
                    resp.aggregations.filtered.clients.buckets.forEach(element => {
                        let client = {};
                        client.name = element.key;
                        clientsList.push(client);
                    });

                }
                setClients(clientsList);

            }, function (err) {
                console.trace(err.message);
            });

    }

    const handleCustomClientSelection = (clientValues) => {
        getCustomFilterData(clientValues);
        if (clientValues.length > 0) {
            setSourceSIDDisable(false);
        }
        else {
            setSourceSIDDisable(true);
            if (props.alertType === "reactive") {
                let sourceElement = document.getElementById('custom_source_type-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
                let systemElement = document.getElementById('custom_filter_sid-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
                sourceElement && sourceElement.click();
                systemElement && systemElement.click();
            } else {
                let sourceElement = document.getElementById('custom_psource_type-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
                let systemElement = document.getElementById('custom_pfilter_sid-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
                sourceElement && sourceElement.click();
                systemElement && systemElement.click();
            }
            setFilterSelections({ ...filterSelections, "client": [], "source_type": [], "filter_sid": [] });
        }
    }

    const handleSAPClientSelection = (clientValues) => {
        getSAPFilterData(clientValues);
        if (clientValues.length > 0) {
            setSIDDisable(false);
        }
        else {
            setSIDDisable(true);
            if (props.alertType === "reactive") {
                let sidElement = document.getElementById('sap-sid-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
                sidElement && sidElement.click();
            }
            else {
                let sidElement = document.getElementById('sap-p_sid-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
                sidElement && sidElement.click();
            }
            setFilterSelections({ ...filterSelections, "client": [], "sid": [] });
        }
    }

    const getCustomFilterData = (clients) => {
        callPostApi(Constants.GETFILTERSID, { 'Content-Type': 'application/json' }, { clientsSelected: clients })
            .then(resp => {
                if (resp) {
                    let sid_List = [];
                    resp.forEach(element => {
                        let filter_sid = {};
                        filter_sid.name = element.key;
                        sid_List.push(filter_sid);
                    });
                    setfilterSIDData(sid_List);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });

        callPostApi(Constants.GETSOURCETYPE, { 'Content-Type': 'application/json' }, { clientsSelected: clients })
            .then(resp => {
                if (resp) {
                    let source_type_List = [];
                    resp.forEach(element => {
                        let source_type = {};
                        source_type.name = element.key;
                        source_type_List.push(source_type);
                    });
                    setSourceTypeData(source_type_List);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    const getSAPFilterData = (clients) => {
        callPostApi(Constants.GETSAPSIDBYCLIENTS, { 'Content-Type': 'application/json' }, { clientsSelected: clients, alertType: props.alertType })
            .then(resp => {
                if (resp) {
                    let sid_List = [];
                    resp.forEach(element => {
                        let sid = {};
                        sid.name = element.key;
                        sid_List.push(sid);
                    });
                    setSapSIDData(sid_List);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    const handleSelectionChange = (type, event) => {
        var selectedValues = event.selectedItems.map(function (k, v) {
            return k.name;
        });

        switch (type) {
            case 'client-select':
                setFilterSelections({ ...filterSelections, "client": selectedValues });
                props.workspace === workspaces.custom_ops && handleCustomClientSelection(selectedValues);
                props.workspace === workspaces.sap_ops && handleSAPClientSelection(selectedValues);
                break;
            case 'technology-select':
                setFilterSelections({ ...filterSelections, "technology": selectedValues });
                break;
            case 'deployment-select':
                setFilterSelections({ ...filterSelections, "deployment_model": selectedValues });
                break;
            case 'geo-select':
                setFilterSelections({ ...filterSelections, "geo": selectedValues });
                break;
            case 'competency-select':
                setFilterSelections({ ...filterSelections, "competency": selectedValues });
                break;
            case 'priority-select':
                setFilterSelections({ ...filterSelections, "priority": selectedValues });
                break;
            case 'incidentStatus-select':
                setFilterSelections({ ...filterSelections, "incidentStatus": selectedValues });
                break;
            case 'assignee-select':
                if (!assigneesDisable) {
                    setFilterSelections({ ...filterSelections, "assignee": selectedValues, "assignee_email": [] });
                } else {
                    setFilterSelections({ ...filterSelections, "assignee": [] });
                }
                break;
            case 'assignee_gp-select':
                setFilterSelections({ ...filterSelections, "assignee_gp": selectedValues });
                break;
            case 'status-select':
                setFilterSelections({ ...filterSelections, "status": selectedValues });
                break;
            case 'automata_activity_name-select':
                setFilterSelections({ ...filterSelections, "automata_activity_name": selectedValues });
                break;
            case 'automata_state-select':
                setFilterSelections({ ...filterSelections, "automata_state": selectedValues });
                break;
            case 'bot_id-select':
                setFilterSelections({ ...filterSelections, "bot_id": selectedValues });
                break;
            case 'provider-select':
                setFilterSelections({ ...filterSelections, "provider": selectedValues });
                break;
            case 'filter_sid-select':
                setFilterSelections({ ...filterSelections, "filter_sid": selectedValues });
                break;
            case 'source_type-select':
                setFilterSelections({ ...filterSelections, "source_type": selectedValues });
                break;
            case 'sid-select':
                setFilterSelections({ ...filterSelections, "sid": selectedValues });
                break;
            default:
        }
    };

    const handleFilterChange = () => {
        if (props.alertType === 'reactive') {
            props.updateState('alertFilterSelections', filterSelections);
            props.updateState('alertFilterData_clients', clients);
        } else {
            props.updateState('pAlertFilterSelections', filterSelections);
            props.updateState('pAlertFilterData_clients', clients);
        }
        props.updateState('disabledSelects', disabledSelects);
        props.handleClose();
    }

    const handleAssignedToMe = (e) => {
        //console.log("toggle click",e);
        let user = JSON.parse(localStorage.getItem('user'));
        if (e === true) {
            // if(document.querySelector('.bx--multi-select .bx--list-box__selection--multi')){
            //     document.querySelector('.bx--multi-select .bx--list-box__selection--multi').remove();
            // }
            setAssignedTome(true);
            setassigneeDisable(true);
            setFilterSelections({ ...filterSelections, "assignee_email": [user.username], "assignee": [] });
        } else {
            setAssignedTome(false)
            setassigneeDisable(false);
            setFilterSelections({ ...filterSelections, "assignee_email": [] });

        }
    }

    const populateInitalSelectedItems = (selections) => {
        let initialValues = [];
        if (selections) {
            selections.map(function (v) {
                initialValues.push({ "name": v });
            });
        }
        return initialValues;
    }

    const handleAssigneeChange = (event) => {

    };

    const clearAll = (e) => {
        setTimeout(() => {
            document.querySelectorAll('.bx--multi-select .bx--list-box__selection--multi').forEach(e => e.click());
        }, 0)
    };

    const FilterBy = i18n.t('filter.FilterBy');
    const franchise = i18n.t('filter.franchise');
    const Client = i18n.t('filter.Client');
    const Clientselection = i18n.t('filter.Clientselection');
    const IncidentStatus = i18n.t('filter.IncidentStatus');
    const Technology = i18n.t('filter.Technology');
    const Priority = i18n.t('filter.FilterPriority');
    const Chooseoptions = i18n.t('filter.Chooseoptions');
    const Addmorefilters = i18n.t('filter.Addmorefilters');
    const Apply = i18n.t('filter.Apply');
    const AssignedTo = i18n.t('filter.AssignedTo');
    const showIncident = i18n.t('filter.ShowIncident');
    const Clear = i18n.t('filter.Clear');
    const AssignmentGp = i18n.t('filter.AssignmentGp');
    const Status = i18n.t('filter.Status');
    const DeploymentModel = i18n.t('filter.DeploymentModel');
    const Geos = i18n.t('filter.Geos');
    const Competencies = i18n.t('filter.Competencies');
    const BotID = i18n.t('filter.BotId');
    const AutomataState = i18n.t('filter.AutomataState');
    const AutomataName = i18n.t('filter.AutomataName');
    const LeadPlatform = i18n.t('filter.LeadPlatform');
    const BotName = i18n.t('filter.BotName');
    const SourceProvider = i18n.t('filter.SourceProvider');
    const SID = i18n.t('filter.SID');
    const SourceType = i18n.t('filter.SourceType');

    return (

        props.alertType === 'reactive' ?
            <div hidden={props.hidden} class="bx--grid bx--grid--full-width filter--page font-family">
                {props.workspace === workspaces.automation_ops ?
                    <div className='filter-grid-manage-ops'>
                        <div class="bx--row">
                            <div class="bx--col-lg-12 bx--col-md-6">
                                <FormLabel className="filter--text">
                                    {FilterBy}
                                </FormLabel>
                            </div>
                        </div>
                        {props.isResourceType === false && props.isQueueType === false ?
                            <div>
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        id='select-assignee'
                                        titleText={AssignedTo}
                                        helperText=''
                                        disabled={assigneesDisable}
                                        label={Chooseoptions}
                                        items={props.filterData.assignees ? props.filterData.assignees : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.assignee)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('assignee-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div>
                                <div className="toggle-filter margin-top-10px">
                                    <div className="show-incident margin-right-10px">{showIncident}</div>
                                    <ToggleSmall
                                        aria-label="toggle button"
                                        id="toggle-2"
                                        labelText=""
                                        toggled={isAssignedTome}
                                        onToggle={(e) => handleAssignedToMe(e)}

                                    />
                                </div> </div> : null}
                        <div className="line-message"></div>

                        <div class="multi-select-row-alert">
                            {/* <div class="bx--col-lg-2 bx--col-md-2"> */}

                            {configConst.URL.includes(configConst.unilever) ? null :
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        id='select'
                                        titleText={franchise}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.franchises ? props.filterData.franchises : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.franchise)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={handleFranchiseSelectionChange}
                                        placeholder={Chooseoptions}
                                    />
                                </div>}
                            {/* <div class="bx--col-lg-2 bx--offset-lg-1 bx--col-md-2"> */}
                            {configConst.URL.includes(configConst.unilever) ? null :
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        id='client-select'
                                        key={clientKey}
                                        titleText={Client}
                                        helperText={Clientselection}
                                        disabled={disabledSelects["client-select"]}
                                        label={Chooseoptions}
                                        items={clients}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('client-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div>}

                            {/* {configConst.URL.includes(configConst.unilever) ? null : */}
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={Technology}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.technologies ? props.filterData.technologies : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.technology)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('technology-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div>
                                {/* } */}
                            {/* <div class="bx--col-lg-2 bx--offset-lg-1 bx--col-md-2 "> */}
                            {configConst.URL.includes(configConst.unilever) ? null :
                                props.isResourceType === false ?
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            titleText={DeploymentModel}
                                            helperText=''
                                            disabled={false}
                                            label={Chooseoptions}
                                            items={props.filterData.deployment_models ? props.filterData.deployment_models : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(props.filterSelections.deployment_model)} translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('deployment-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div> : null}
                            {/* <div class="bx--col-lg-2 bx--col-md-2 "> */}
                            {props.isResourceType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={Geos}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.geos ? props.filterData.geos : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.geo)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('geo-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {/* <div class="bx--col-lg-2 bx--offset-lg-1 bx--col-md-2 "> */}
                            {props.isResourceType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={configConst.URL.includes(configConst.unilever) ? LeadPlatform : Competencies}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.competencies ? props.filterData.competencies : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={props.filterSelections.competency ? props.filterSelections.competency.map(function (v) {
                                            return { "name": v };
                                        }) : []}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('competency-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {/* <div class="bx--col-lg-2 bx--offset-lg-1 bx--col-md-2 "> */}
                            {props.isResourceType === false && props.isQueueType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={Priority}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.priorities ? props.filterData.priorities : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.priority)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('priority-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {props.isResourceType === false && props.isQueueType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={Status}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.status ? props.filterData.status : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.status)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('status-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {props.isResourceType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={AutomataState}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.automata_state ? props.filterData.automata_state : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.automata_state)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('automata_state-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {props.isResourceType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={configConst.URL.includes(configConst.unilever) ? BotName : AutomataName}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.automata_activity_name ? props.filterData.automata_activity_name : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.automata_activity_name)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('automata_activity_name-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {props.isResourceType === false ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={BotID}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.bot_id ? props.filterData.bot_id : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.bot_id)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('bot_id-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                        </div>
                    </div> :
                    <div className='filter-grid-manage-ops'>
                        <div class="bx--row">
                            <div class="bx--col-lg-12 bx--col-md-6">
                                <FormLabel className="filter--text">
                                    {FilterBy}
                                </FormLabel>
                            </div>
                        </div>

                        <div class="multi-select-filter-alert">
                            <MultiSelect.Filterable
                                {...multiselectprops}
                                id='select'
                                titleText={AssignedTo}
                                helperText=''
                                disabled={assigneesDisable}
                                label={Chooseoptions}
                                items={props.filterData.assignees ? props.filterData.assignees : []}
                                itemToString={(item) => (item ? item.name : '')}
                                initialSelectedItems={populateInitalSelectedItems(props.filterSelections.assignee)}
                                translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                selectionFeedback={multiselectprops.selectionFeedback}
                                onChange={(e) => handleSelectionChange('assignee-select', e)}
                                placeholder={Chooseoptions}
                            />
                        </div>
                        <div className="toggle-filter margin-top-10px">
                            <div className="show-incident margin-right-10px">{showIncident}</div>
                            <ToggleSmall
                                aria-label="toggle button"
                                id="toggle-2"
                                labelText=""
                                toggled={isAssignedTome}
                                onToggle={(e) => handleAssignedToMe(e)}
                            />
                        </div>
                        <div className="line-message"></div>
                        <div class="multi-select-row-alert">
                            <div class="multi-select-filter-alert">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='select'
                                    titleText={franchise}
                                    helperText=''
                                    disabled={false}
                                    label={Chooseoptions}
                                    items={props.filterData.franchises ? props.filterData.franchises : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(props.filterSelections.franchise)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={handleFranchiseSelectionChange}
                                    placeholder={Chooseoptions}
                                />
                            </div>
                            <div class="multi-select-filter-alert">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='client-select'
                                    titleText={Client}
                                    key={clientKey}
                                    helperText={Clientselection}
                                    disabled={disabledSelects["client-select"]}
                                    label={Chooseoptions}
                                    items={clients}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('client-select', e)}
                                    placeholder={Chooseoptions}
                                />
                            </div>
                            <div class="multi-select-filter-alert">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Priority}
                                    helperText=''
                                    disabled={false}
                                    label={Chooseoptions}
                                    items={props.filterData.priorities ? props.filterData.priorities : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(props.filterSelections.priority)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('priority-select', e)}
                                    placeholder={Chooseoptions}
                                />
                            </div>
                            {props.workspace === workspaces.custom_ops ?
                                <>
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id='custom_filter_sid-select'
                                            titleText={SID}
                                            helperText=''
                                            key={filterSIDKey}
                                            disabled={sourceSIDDisable}
                                            label={Chooseoptions}
                                            items={filterSIDData ? filterSIDData : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.filter_sid)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('filter_sid-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div>
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id='custom_source_type-select'
                                            titleText={SourceType}
                                            helperText=''
                                            key={sourceTypeKey}
                                            disabled={sourceSIDDisable}
                                            label={Chooseoptions}
                                            items={sourceTypeData ? sourceTypeData : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.source_type)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('source_type-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div>
                                </>
                                : null}

                            {props.workspace === workspaces.sap_ops ?
                                <>
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            titleText={Status}
                                            helperText=''
                                            disabled={false}
                                            label={Chooseoptions}
                                            items={props.filterData.incidentStatus ? props.filterData.incidentStatus : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(props.filterSelections.incidentStatus)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('incidentStatus-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div>
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id="sap-sid-select"
                                            titleText={SID}
                                            helperText=''
                                            key={sapSIDKey}
                                            disabled={SIDDisable}
                                            label={Chooseoptions}
                                            items={sapSIDData ? sapSIDData : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.sid)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('sid-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div>
                                </> : null}
                            {props.status !== 'Informational' && props.workspace !== workspaces.custom_ops ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        id='select'
                                        titleText={AssignmentGp}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.assignee_gp ? props.filterData.assignee_gp.filter(e => e.name) : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.assignee_gp)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('assignee_gp-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div>
                                : null}
                        </div>
                    </div>}
                <div class="bottom-button">
                    {/* <div class="bx--col-lg-2"> */}
                    {/* <Button kind="ghost">
                           {Addmorefilters} <ChevronDown16 />
                        </Button> */}
                    <div>
                        <Button kind='ghost' onClick={clearAll}>
                            {Clear}
                        </Button>
                        <Button kind='ghost' onClick={handleFilterChange}>
                            {Apply}
                        </Button>
                    </div>
                </div>

            </div>
            :
            <div hidden={props.hidden} class="bx--grid bx--grid--full-width filter--page">
                {configConst.URL.includes(configConst.unilever) ? null :

                    <div className='filter-grid-manage-ops'>
                        <div class="bx--row">
                            <div class="bx--col-lg-4">
                                <div className="filter--text">
                                    {FilterBy}
                                </div>
                            </div>
                        </div>

                        <div class="multi-select-filter-alert">
                            <MultiSelect.Filterable
                                {...multiselectprops}
                                id='select'
                                titleText={AssignedTo}
                                helperText=''
                                disabled={assigneesDisable}
                                label={Chooseoptions}
                                items={props.filterData.assignees ? props.filterData.assignees : []}
                                itemToString={(item) => (item ? item.name : '')}
                                initialSelectedItems={populateInitalSelectedItems(props.filterSelections.assignee)}
                                translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                selectionFeedback={multiselectprops.selectionFeedback}
                                onChange={(e) => handleSelectionChange('assignee-select', e)}
                                placeholder={Chooseoptions}
                            />
                        </div>

                        <div className="line-message" style={{ marginTop: "10px" }}></div>
                        <div class="multi-select-row-alert">
                            <div class="multi-select-filter-alert">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={franchise}
                                    helperText=''
                                    disabled={false}
                                    label={Chooseoptions}
                                    items={props.filterData.franchises ? props.filterData.franchises : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(props.filterSelections.franchise)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={handleFranchiseSelectionChange}
                                    placeholder={Chooseoptions}
                                />
                            </div>
                            <div class="multi-select-filter-alert">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='client-select'
                                    titleText={Client}
                                    key={clientKey}
                                    helperText={Clientselection}
                                    disabled={disabledSelects["client-select"]}
                                    label={Chooseoptions}
                                    items={clients}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('client-select', e)}
                                    placeholder={Chooseoptions}
                                />
                            </div>
                            <div class="multi-select-filter-alert">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Priority}
                                    helperText=''
                                    disabled={false}
                                    label={Chooseoptions}
                                    items={props.filterData.priority ? props.filterData.priority : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(props.filterSelections.priority)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('priority-select', e)}
                                    placeholder={Chooseoptions}
                                />
                            </div>

                            {props.alertType === 'Infra Alert' ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={Status}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.incidentStatus ? props.filterData.incidentStatus : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.incidentStatus)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('incidentStatus-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {props.alertType === 'Infra Alert' ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={SourceProvider}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.provider ? props.filterData.provider : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.provider)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('provider-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                            {props.workspace === workspaces.custom_ops && props.alertType === 'Infra Alert' ?
                                <>
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id='custom_pfilter_sid-select'
                                            titleText={SID}
                                            helperText=''
                                            key={filterSIDKey}
                                            disabled={sourceSIDDisable}
                                            label={Chooseoptions}
                                            items={filterSIDData ? filterSIDData : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.filter_sid)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('filter_sid-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div>
                                    <div class="multi-select-filter-alert">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id='custom_psource_type-select'
                                            titleText={SourceType}
                                            helperText=''
                                            key={sourceTypeKey}
                                            disabled={sourceSIDDisable}
                                            label={Chooseoptions}
                                            items={sourceTypeData ? sourceTypeData : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.source_type)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('source_type-select', e)}
                                            placeholder={Chooseoptions}
                                        />
                                    </div>
                                </>
                                : null}
                            {props.workspace === workspaces.sap_ops && props.alertType === 'Infra Alert' ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        id="sap-p_sid-select"
                                        titleText={SID}
                                        helperText=''
                                        key={sapSIDKey}
                                        disabled={SIDDisable}
                                        label={Chooseoptions}
                                        items={sapSIDData ? sapSIDData : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(filterSelections.sid)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('sid-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div>
                                : null}
                            {props.workspace === workspaces.automation_ops ?
                                <div class="multi-select-filter-alert">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={DeploymentModel}
                                        helperText=''
                                        disabled={false}
                                        label={Chooseoptions}
                                        items={props.filterData.deployment_models ? props.filterData.deployment_models : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(props.filterSelections.deployment_model)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('deployment-select', e)}
                                        placeholder={Chooseoptions}
                                    />
                                </div> : null}
                        </div>
                        <div class="bottom-button">
                            {/* <div class="bx--col-lg-2"> */}
                            {/* <Button kind="ghost">
                           {Addmorefilters} <ChevronDown16 />
                        </Button> */}
                            <div>
                                <Button kind='ghost' onClick={clearAll}>
                                    {Clear}
                                </Button>
                                <Button kind='ghost' onClick={handleFilterChange}>
                                    {Apply}
                                </Button>
                            </div>
                        </div>
                    </div>}
            </div>

    );
};
export default Filters;
